module.exports = __webpack_public_path__ + "static/media/left.d4477ae0.svg";